import React, { FC } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { useTogglePlayWithIndicator } from '../../../hooks/skin/use-toggle-play-with-indicator';
import { useToggleOnAirWithIndicator } from '../../../hooks/skin/use-toggle-on-air-with-indicator';

import styles from './styles.module.css';

interface Props {
    className?: string;
    isChannel?: boolean;
}

export const PlayButton: FC<Props> = ({ className, isChannel }) => {
    const { togglePlay } = useTogglePlayWithIndicator();
    const { toggleOnAir } = useToggleOnAirWithIndicator();
    const intl = useIntl();

    return (
        <button
            onClick={isChannel ? toggleOnAir : togglePlay}
            className={classnames(styles.root, className)}
            aria-label={intl.formatMessage({
                id: 'features.player.de3c731be5633838089a07179d301d7b',
                defaultMessage: 'Play',
                description: 'Текст лейбла кнопки запуска воспроизведения',
            })}
        >
            <span className={styles.playIcon} />
        </button>
    );
};
